import { connect } from 'react-redux';
import MonitorWSService from 'src/services/monitorwsservice';
import { notify } from "src/components/utils/utils";
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

function AlarmsNotificator(props) {

    const { t } = useTranslation();

    useEffect(() => {
        // component mounts
        return () => {
            // component unmounts

            if (MonitorWSService.stompClient?.connected) {
                MonitorWSService.stompClient.unsubscribe("queuealarm");
                MonitorWSService.stompClient.unsubscribe("conversationalarm");
                MonitorWSService.stompClient.unsubscribe("pausetimealarm");
                MonitorWSService.stompClient.unsubscribe("agentsactivityalarm");
                MonitorWSService.stompClient.unsubscribe("dialersactivityalarm");
                MonitorWSService.stompClient.unsubscribe("droppedcallsalarm");
            }

        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    useEffect(() => {

        if (props.connected) {

            MonitorWSService.stompClient.subscribe(`/user/${props.token}/topic/queuealarm/`, function (calls) {
                if (props.notify) {
                    var data = JSON.parse(calls.body);
                    if (data.length > 0) {
                        var groups = data.map(x => x.groupName).join(", ");
                        notify(t("maxqueuetimeexceeded"), groups, props.notifyAudio);
                    }
                }
            }, { id: "queuealarm" });

            MonitorWSService.stompClient.subscribe(`/user/${props.token}/topic/conversationalarm/`, function (agents) {
                if (props.notify) {
                    var data = JSON.parse(agents.body);
                    if (data.length > 0) {
                        var agentsNames = data.map(x => x.fullName).join(", ");
                        notify(t("maxtalkingtime"), agentsNames, props.notifyAudio);
                    }
                }
            }, { id: "conversationalarm" });

            MonitorWSService.stompClient.subscribe(`/user/${props.token}/topic/pausetimealarm/`, function (agents) {
                if (props.notify) {
                    var data = JSON.parse(agents.body);
                    if (data.length > 0) {
                        var agentsNames = data.map(x => x.fullName).join(", ");
                        notify(t("pausetimeexceeded"), agentsNames, props.notifyAudio);
                    }
                }
            }, { id: "pausetimealarm" });

            MonitorWSService.stompClient.subscribe(`/user/${props.token}/topic/droppedcallsalarm/`, function (agents) {
                if (props.notify) {
                    var data = JSON.parse(agents.body);
                    if (data.length > 0) {
                        var agentsNames = data.map(x => x.fullName).join(", ");
                        notify(t("maxmissedcalls"), agentsNames, props.notifyAudio);
                    }
                }
            }, { id: "droppedcallsalarm" });

            MonitorWSService.stompClient.subscribe(`/user/${props.token}/topic/agentsactivityalarm/`, function (agents) {
                if (props.notify) {
                    var data = JSON.parse(agents.body);

                    if (data.length > 0) {
                        var agentsNames = data.map(x => x.fullName).join(", ");
                        notify(t("useractivity"), agentsNames, props.notifyAudio);
                    }
                }

            }, { id: "agentsactivityalarm" });

            MonitorWSService.stompClient.subscribe(`/user/${props.token}/topic/dialersactivityalarm/`, function (dialers) {
                if (props.notify) {
                    var data = JSON.parse(dialers.body);

                    if (data.length > 0) {
                        var dialersNames = data.join(", ");
                        notify(t("dialeractivity"), dialersNames, props.notifyAudio);
                    }
                }
            }, { id: "dialersactivityalarm" });

            MonitorWSService.stompClient.subscribe(`/user/${props.token}/topic/fromopenalarm/`, function (agents) {
                if (props.notify) {
                    var data = JSON.parse(agents.body);

                    if (data.length > 0) {
                        var agentsNames = data.map(x => x.fullName).join(", ");
                        notify(t("formopenedalarm"), agentsNames, props.notifyAudio);
                    }
                }

            }, { id: "fromopenalarm" });
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.connected, props.notify, props.notifyAudio]);

    return (<></>);
}


const mapStateToProps = (state) => {
    return {
        token: state.supervisor.token,
        connected: state.parameters.connected,
        notify: state.parameters.notify,
        notifyAudio: state.parameters.notifyAudio
    };
};


export default connect(mapStateToProps, {})(AlarmsNotificator);